import { typographyStyles, mediaQueryStyles } from "@newsela/angelou";

const { textSObj } = typographyStyles;
const { mobileFirstCss } = mediaQueryStyles;

export const badgeCss = mobileFirstCss({
  maxWidth: "unset",
  div: {
    overflow: "unset",
    ...textSObj,
  },
});
